export default __webpack_public_path__ + "static/media/image-gallery-1.0f70794c.jpg";